import React from 'react';
import { Link } from 'react-router-dom';
import { WrapperStyle } from './style';

export default function WrapperListHeader() {
  return (
    <WrapperStyle>
      <h2>Pessoas Cadastradas</h2>
      <Link to="/registro-pessoa">Cadastrar nova pessoa +</Link>
    </WrapperStyle>
  );
}
